export default "__VITE_ASSET__2b5f31b0__"